import React, { useEffect, useState } from "react";
import {
  Table,
  TableContainer,
  TableHead,
  Paper,
  Typography,
  TableCell,
  Box,
} from "@mui/material";
import { fetchAnnualIncrement } from "../../services/api/dashboard";
import { ANNUAL_INCREMENT_TABLE_HEADERS } from "../../constant/TableHeaders";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/toastSlice";
import {
  StyledTableBody,
  TableBodyRow,
  TableHeaderRow,
} from "../../styles/TableStyles";
import { INDIAN_RUPEE_SIGN } from "../../constant/constant";

const AnnualIncrement = () => {
  const dispatch = useDispatch();
  // -----------useState----------------------
  const [annualIncrement, setAnnualIncrement] = useState([]);

  // ------------useEffect------------------------
  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        const transactions = await fetchAnnualIncrement();
        setAnnualIncrement(transactions.data); // Set the fetched transactions
      } catch (error) {
        dispatch(showToast({ message: error.message, severity: "error" }));
      }
    };

    fetchTransactions();
  }, []);

  if (annualIncrement.length === 0) {
    return (
      <Typography variant="h6" sx={{ color: "#c02b10", mt: 2 }}>
        There are no entries to display.
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="h5" sx={{ mt: 8, mb: 1 }}>
        Tenant Annual Increment Date
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: "#999" }}>
        Stay updated with the upcoming increments in the rent of tenants.
      </Typography>
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          borderRadius: 2,
          backgroundColor: "#fff",
          boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: 2,
            p: 2,
          }}
        >
          <TableContainer>
            <Table>
              <TableHead>
                <TableHeaderRow>
                  {ANNUAL_INCREMENT_TABLE_HEADERS.map((item, index) => (
                    <TableCell
                      key={index}
                      align={item.alignItemTo}
                      sx={{ width: item.width }}
                    >
                      {item.title}
                    </TableCell>
                  ))}
                </TableHeaderRow>
              </TableHead>

              <StyledTableBody>
                {annualIncrement.map((item) => (
                  <TableBodyRow
                    key={item.id}
                    hover
                    sx={{
                      "&:hover": {
                        backgroundColor: "#f9f9f9",
                      },
                    }}
                  >
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {new Date(item.annual_increment_date).toLocaleDateString(
                        "en-GB"
                      )}
                    </TableCell>

                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {`${item.tenant_first_name} ${item.tenant_last_name}`}
                    </TableCell>

                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {item.tenant_contact}
                    </TableCell>

                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {new Date(item.entry_date).toLocaleDateString("en-GB")}
                    </TableCell>

                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {` ${INDIAN_RUPEE_SIGN} ${item.rent_amount}`}
                    </TableCell>
                    <TableCell sx={{ width: 250, alignItemTo: "left" }}>
                      {` ${INDIAN_RUPEE_SIGN} ${item.total_rent_amount}`}
                    </TableCell>
                  </TableBodyRow>
                ))}
              </StyledTableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    </>
  );
};

export default AnnualIncrement;
